import React from "react";
import useScrollReveal from "@/hooks/useScrollReveal";

import HeroMain from "@/components/site/HeroMain";
import CategoryTabs from "@/components/site/CategoryTabs";
import ProcessMain from "@/components/site/main/ProcessMain";
import WhatWeOfferMain from "@/components/site/main/WhatWeOfferMain";
import ProjectCatalogue from "@/components/site/ProjectCatalogue";
import TrustedPartners from "@/components/site/TrustedPartners";
import CostEstimatorMain from "@/components/site/main/CostEstimatorMain";
import LaunchOfferMain from "@/components/site/main/LaunchOfferMain";
import FAQ, { MAIN_FAQS } from "@/components/site/FAQ";
import PreFooterCTAMain from "@/components/site/main/PreFooterCTAMain";
import SEO from "@/components/site/SEO";
import { pageSeo, localBusinessJsonLd, faqJsonLd } from "@/lib/seo-config";

export default function MainHome() {
    useScrollReveal();
    return (
        <main data-testid="page-main-home">
            <SEO
                {...pageSeo.home}
                jsonLd={[localBusinessJsonLd, faqJsonLd(MAIN_FAQS)]}
            />
            <HeroMain />
            <CategoryTabs />
            <ProcessMain />
            <ProjectCatalogue />
            <WhatWeOfferMain />
            <TrustedPartners />
            <CostEstimatorMain />
            <LaunchOfferMain />
            <FAQ items={MAIN_FAQS} />
            <PreFooterCTAMain />
        </main>
    );
}
